import React, {Component} from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import "./App.scss";
import MessageBox from "./components/MessageBox";
import Dialog from "./components/Dialog";
import ProgressCustom from "./components/ProgressCustom";
import DialogSecond from "./components/DialogSecond";
import Constants from "./configs/Constants";
import {Cookies} from "react-cookie";
import Sso from "./views/Pages/Sso";

const cookie = new Cookies();
const DefaultLayout = React.lazy(() => import("./components/DefaultLayout"));
const loading = () => (
    <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

const Login = React.lazy(() => import("./views/Login/login"));
const Logout = React.lazy(() => import("./views/Login/logout"));
const Dashboard = React.lazy(() => import("./views/LinkApp/LinkApp"));
class App extends Component {
    constructor(props) {
        super(props);
    }

    checkLogged() {
        let tokenLogged = cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED);
        if ((tokenLogged === undefined || tokenLogged === "")) {
            return false;
        }
        return true;
    }

    render() {
        return (
            <BrowserRouter  basename={window.globalConfig.PUBLIC_URL}>
                <React.Suspense fallback={loading()}>
                    <MessageBox/>
                    <Dialog/>
                    <DialogSecond/>
                    <ProgressCustom/>
                    <Switch>
                        <Route path="/login" component={Login}></Route>
                        <Route path="/logout" component={Logout}></Route>
                        <Route path="/" component={Dashboard}/>
                    </Switch>
                </React.Suspense>
            </BrowserRouter>
        );
    }
}

export default App;
